import { shippingAddressInfoDisplayStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/ShippingAddressInfoDisplay";
import { css } from "styled-components";

shippingAddressInfoDisplayStyles.addressGridItem = {
    width: 12,
    css: css`
        padding-right: 25px;
    `,
};